<template>
  <div class="ride-booking-rating">
    <div class="card">
      <div class="card-content">
        <p class="subtitle">{{ $t("passenger.rating") }}</p>
        <rating
          :items="items"
          @change="submitRating"
          style="margin: 0 auto; flex: box; min-height: 50px"
        />

        <button
          class="button is-grey is-rounded is-small close-btn"
          v-show="showCloseRating"
          @click="close"
        >
          {{ $t("close") }}
        </button>

        <button
          v-if="$store.getters.isDriver"
          class="button is-danger is-rounded is-small is-outlined delete-btn"
          @click="softDelete"
        >
          {{ $t("driver.delete-test") }}
        </button>
      </div>
    </div>
  </div>
</template>


<script>
import Rating from "vue-bulma-rating";

export default {
  name: "RideBookingRating",
  components: {
    Rating,
  },
  props: {
    t: Object, // transaction
  },
  data() {
    return {
      showCloseRating: true, // should show this only if user already tried to submit rating
      items: [
        { title: "5 Stars", value: 5 },
        { title: "4 Stars", value: 4 },
        { title: "3 Stars", value: 3 },
        { title: "2 Stars", value: 2 },
        { title: "1 Star", value: 1 },
      ],
    };
  },
  methods: {
    close() {
      this.$emit("close");
    },
    submitRating(e) {
      this.console("submitRating", e); // TODO submit driver rating, store in DB
      this.$swal({
        type: "success",
        title: this.$t("passenger.feedback-thankyou"), //"Thank you for your feedback!",
        text: this.$t("passenger.feedback-text"),
        showConfirmButton: false,
        timer: 3000,
      });
      this.close();
    },
    softDelete() {
      var loader = this.loadingDots("pink");
      this.$store
        .dispatch("deleteTransaction", this.t.id)
        .then(() => {
          this.thankYou();
          this.updateTransactionsForCustomer(true);
          this.close();
        })
        .catch((err) => this.apiError(err))
        .finally(() => loader.hide());
    },
  },
};
</script>

<style scoped>
.card-content {
  padding: 12px;
  text-align: left;
}
.subtitle {
  margin-bottom: 8px;
}
.close-btn {
  position: absolute;
  left: 0;
  bottom: 0;
  margin: 10px;
}
.delete-btn {
  position: absolute;
  right: 0;
  bottom: 0;
  margin: 10px;
}
</style>